import type { BlueprintForegroundColorModifier } from '@/grove-blueprints/generated-types'

const FOREGROUND_COLOR_CLASS: Record<
  BlueprintForegroundColorModifier['token'],
  string
> = {
  primaryGreen: 'text-acorns-green contrast-more:text-acorns-ada-dark-green',
  primaryPurple: 'text-acorns-purple',
  primaryForest: 'text-acorns-forest',
  primarySunrise: 'text-acorns-sunrise',
  primaryError: 'text-error',
  primaryGoHenry: 'text-acorns-go-henry',
  primarySky: 'text-acorns-sky',
  primarySlate: 'text-acorns-slate',
  primaryStone: 'text-acorns-stone',
  primaryStoneLight: 'text-acorns-stone-light',
  primaryIvory: 'text-acorns-ivory',
  primaryIvoryLight: 'text-acorns-ivory-light',
  primaryWhite: 'text-white',
  naturalEcru: 'text-acorns-ecru',
  naturalCloud: 'text-acorns-cloud',
  naturalBeige: 'text-acorns-beige',
  naturalSand: 'text-acorns-sand',
  naturalBark: 'text-acorns-bark',
  naturalMushroom: 'text-acorns-mushroom',
  naturalAmber: 'text-acorns-amber',
  naturalFern: 'text-acorns-fern',
  naturalLightOak: 'text-acorns-light-oak',
  naturalDarkOak: 'text-acorns-dark-oak',
  naturalMoss: 'text-acorns-moss',
  naturalDarkForest: 'text-acorns-dark-forest',
  naturalEmerald: 'text-acorns-emerald',
  naturalMidnightForest: 'text-acorns-midnight-forest',
  naturalPlum: 'text-acorns-plum',
  naturalDusk: 'text-acorns-dusk',
  naturalCharcoal: 'text-acorns-charcoal',
  naturalRosewood: 'text-acorns-rosewood',
  naturalGold1: 'text-acorns-gold-1',
  naturalGold2: 'text-acorns-gold-2',
}

export function resolveForegroundColorModifier(
  modifier: BlueprintForegroundColorModifier,
): string {
  return FOREGROUND_COLOR_CLASS[modifier.token]
}
